import { API_URL, apiFetch } from "./api";

export async function createCertificate(payload) {
  const response = await apiFetch("/api/certificates", {
    method: "POST",
    body: payload,
  });

  return response.certificate;
}

export async function publishCertificate(uuid) {
  try {
    const response = await apiFetch(`/api/certificates/${uuid}/publish`, {
      method: "POST",
    });

    return response.certificate || response.data?.certificate || response.data;
  } catch (error) {
    const responseData =
      error?.response?.data || error?.data || error?.payload || null;

    const publication =
      responseData?.certificate?.publication || error?.publication || null;

    const publicationError = new Error(
      responseData?.message ||
        error?.message ||
        "Não foi possível publicar o certificado no servidor externo."
    );

    publicationError.code =
      responseData?.code ||
      publication?.last_error_code ||
      error?.code ||
      "CERTIFICATE_PUBLICATION_FAILED";

    publicationError.status = error?.response?.status || error?.status || null;

    publicationError.publication = publication;

    throw publicationError;
  }
}

export async function listCertificates(params = {}) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();

  return apiFetch(`/api/certificates${queryString ? `?${queryString}` : ""}`, {
    method: "GET",
  });
}

export async function getCertificate(certificateUuid) {
  const response = await apiFetch(`/api/certificates/${certificateUuid}`, {
    method: "GET",
  });

  return response.certificate;
}

export async function uploadCertificatePdf(certificateUuid, pdfBlob) {
  const formData = new FormData();

  formData.append(
    "file",
    pdfBlob,
    `${certificateUuid || "certificado"}-original.pdf`
  );

  const response = await apiFetch(
    `/api/certificates/${certificateUuid}/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  return response.certificate;
}

export async function downloadCertificatePdf(certificateUuid) {
  const response = await fetch(
    `${API_URL}/api/certificates/${certificateUuid}/download`,
    {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/pdf",
      },
    }
  );

  if (!response.ok) {
    let message = "Não foi possível baixar o PDF processado.";

    try {
      const data = await response.json();
      message = data.message || message;
    } catch {
      // resposta pode não ser JSON
    }

    throw new Error(message);
  }

  const blob = await response.blob();

  return {
    blob,
    filename: getFilenameFromResponse(response) || `${certificateUuid}.pdf`,
  };
}

function getFilenameFromResponse(response) {
  const disposition = response.headers.get("Content-Disposition");

  if (!disposition) {
    return null;
  }

  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);

  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const normalMatch = disposition.match(/filename="?([^"]+)"?/i);

  if (normalMatch?.[1]) {
    return normalMatch[1];
  }

  return null;
}
